import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';

export default class ProcedureModifier extends BackboneElement {
    static __className = 'ProcedureModifier';

    __objectStructure = {
        code: String,
        position: Number,
        includeByDefault: Boolean,
    };

    constructor(constructJson, className = 'ProcedureModifier') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
